export default "__VITE_ASSET__DHvl6FMj__"